import { InjectionToken } from '@angular/core';
import { createMocks } from '@backbase/foundation-ang/data-http';
import contacts from './raw-mocks/contacts';
export const CONTACTS_DATA_HTTP_ANG_CONFIG = new InjectionToken(
  'product-summary-data-http-ang Data Service :: HTTP Config',
);
const examples = [
  {
    //urlPattern: '/client-api/{version}/contacts/',
    urlPattern: '/client-api/v2/contacts',
    method: 'GET',
    responses: [
      {
        status: 200,
        body: contacts
      },
    ],
  },
];
export const ContactsHttpServiceGetContactsMocksProvider = createMocks(examples, CONTACTS_DATA_HTTP_ANG_CONFIG);
